import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from '../../lib/lucide-proxy';
import Button from '../ui/Button';
import { useNavigate } from 'react-router-dom';

const CallToAction = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-20 bg-dark-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1559526323-cb2f2fe2591b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center" />
        <div className="absolute inset-0 bg-dark-900/80" />
      </div>
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display font-bold text-4xl sm:text-5xl text-white mb-6">
            É dono de Cervejaria?
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto">
            Junte-se à nossa comunidade e apresente sua história e seus produtos para milhares de apreciadores de cerveja artesanal.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              variant="primary" 
              size="lg" 
              className="w-full sm:w-auto px-8"
              onClick={() => navigate('/register')}
            >
              Cadastrar Cervejaria Grátis
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="w-full sm:w-auto bg-transparent text-white border-white hover:bg-white hover:text-dark-900"
              onClick={() => navigate('/como-funciona')}
            >
              Saiba Mais
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;